import CampaignsPageCommon from '../../components/Campaigns/CampaignsPageCommon';
import WorkflowsCards from '../../components/Workflows/WorkflowsCards';

const WorkflowsPage = () => {
  return <CampaignsPageCommon type="workflow" Cards={WorkflowsCards} />;
};

export default WorkflowsPage;
